import React from 'react';
import SpecialDays from './SpecialDays';

export default (props) => <SpecialDays {...props}/>;
